module.exports = __webpack_public_path__ + "static/img/bg-8.9db63949.jpg";